import { render, staticRenderFns } from "./AdminProductVariants.vue?vue&type=template&id=1c056de1&scoped=true"
import script from "./AdminProductVariants.vue?vue&type=script&lang=js"
export * from "./AdminProductVariants.vue?vue&type=script&lang=js"
import style0 from "./AdminProductVariants.vue?vue&type=style&index=0&id=1c056de1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c056de1",
  null
  
)

export default component.exports